import { useId } from 'react';
import styled from 'styled-components';

const NeonSvg = styled.svg`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-bottom: 1px solid var(--collection-color);
`;

export const Neon = ({ color }: { color: string }) => {
  const filter = useId();
  return (
    <NeonSvg
      width="308"
      height="45"
      viewBox="0 0 308 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: 'plus-lighter' }}>
        <g
          style={{ mixBlendMode: 'plus-lighter' }}
          filter={`url(#${filter}-1)`}
        >
          <ellipse
            cx="154.333"
            cy="45"
            rx="154.5"
            ry="2"
            transform="rotate(-180 154.333 45)"
            fill={color}
          />
        </g>
        <g
          style={{ mixBlendMode: 'plus-lighter' }}
          opacity="0.2"
          filter={`url(#${filter}-2)`}
        >
          <ellipse
            cx="154.333"
            cy="45.5"
            rx="154.5"
            ry="17.5"
            transform="rotate(-180 154.333 45.5)"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <filter
          id={`${filter}-1`}
          x="-4.16699"
          y="39"
          width="317"
          height="12"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_2931_12172"
          />
        </filter>
        <filter
          id={`${filter}-2`}
          x="-28.167"
          y="0"
          width="365"
          height="91"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14"
            result="effect1_foregroundBlur_2931_12172"
          />
        </filter>
      </defs>
    </NeonSvg>
  );
};
